import { render, staticRenderFns } from "./sentToClient.vue?vue&type=template&id=4b277458"
import script from "./sentToClient.vue?vue&type=script&lang=js"
export * from "./sentToClient.vue?vue&type=script&lang=js"
import style0 from "./sentToClient.vue?vue&type=style&index=0&id=4b277458&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports